import React from 'react';
import { Info } from 'lucide-react';
import RiskDynamicsScatterChart, {
    type RiskDynamicsSite,
} from 'src/shared/components/charts/risk-dynamics-scatter-chart/RiskDynamicsScatterChart';
import QuestionButtonHelp from 'src/shared/components/question-button-help/QuestionButtonHelp';
import Loader from 'src/shared/components/loader/Loader';

type Props = {
    sites: RiskDynamicsSite[];
    highlightedSiteId?: string;
    truncated?: boolean;
    siteLimit?: number;
    isLoading?: boolean;
    totalCount?: number | null;
};

export default function RiskDynamicsBreakdownCard({
    sites,
    highlightedSiteId,
    truncated = false,
    siteLimit,
    isLoading = false,
    totalCount = null,
}: Props) {
    const showLoader = isLoading && sites.length === 0;
    const showProgress = isLoading && totalCount !== null && totalCount > 0;

    return (
        <div className='bg-white rounded-card shadow-xs p-5 flex flex-col gap-2.5'>
            <div className='flex items-center gap-2'>
                <h4 className='text-primary text-xl font-normal tracking-tight leading-snug'>Impact-Dependency Action Matrix</h4>
                <QuestionButtonHelp
                    type='api'
                    slug='gnr-quadrant-learn-more-explainer'
                    placement='bottom'
                    icon={<Info className='h-4 w-4 text-primary' />}
                />
                {showProgress && (
                    <span className='ml-auto text-xs text-muted-foreground'>
                        {sites.length.toLocaleString()} / {totalCount!.toLocaleString()} sites loaded
                    </span>
                )}
                {!showProgress && truncated && siteLimit && (
                    <span className='ml-auto text-xs text-muted-foreground'>Showing first {siteLimit.toLocaleString()} sites</span>
                )}
            </div>
            {showLoader ? (
                <div className='flex items-center justify-center h-[300px] mt-4'>
                    <Loader />
                </div>
            ) : (
                <RiskDynamicsScatterChart sites={sites} highlightedSiteId={highlightedSiteId} />
            )}
        </div>
    );
}
